/**
 * Argon Cart Extras — auto-add companion products, quantity sync, discount code.
 */
(function () {
  if (window.ArgonCartExtras) return;

  var COMPANION_MARKER = '_argon_companion';
  var COMPANION_PROP = '_argon_companion_for';
  var ADDON_PROP = '_argon_addon_id';
  var GIFT_PROP = 'Gaveinnpakning';
  var SYNC_COOLDOWN_MS = 180;
  var syncing = false;
  var syncPending = false;
  var syncPendingMerge = false;
  var debounceTimer = null;
  var syncCooldownUntil = 0;
  var config = null;

  function getRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function readConfig() {
    var el = document.getElementById('argon-cart-extras-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[ArgonCartExtras] Invalid config JSON', e);
      return null;
    }
  }

  function isOurCompanion(item) {
    if (!item.properties) return false;
    if (item.properties[COMPANION_MARKER]) return true;
    if (item.properties[COMPANION_PROP] || item.properties['_argon_companion_for']) return true;
    return false;
  }

  function isMonkOrLegacyAddon(item) {
    if (isOurCompanion(item)) return false;
    if (config && config.addonVariantIds && config.addonVariantIds.indexOf(String(item.variant_id)) !== -1) {
      return true;
    }
    if (!item.properties) return false;
    var keys = Object.keys(item.properties);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var val = String(item.properties[key] || '');
      if (/monk/i.test(key) || /monk/i.test(val)) return true;
      if (/complimentary/i.test(val)) return true;
    }
    return false;
  }

  function isCompanionItem(item) {
    return isOurCompanion(item);
  }

  function isAddonVariant(variantId) {
    if (!config || !config.addonVariantIds) return false;
    return config.addonVariantIds.indexOf(String(variantId)) !== -1;
  }

  function itemMatchesRule(item, rule) {
    if (isCompanionItem(item) || isAddonVariant(item.variant_id)) return false;

    switch (rule.triggerType) {
      case 'collection':
      case 'tag':
        return rule.triggerHandles && rule.triggerHandles.indexOf(item.handle) !== -1;
      case 'product_list':
        return (
          rule.triggerVariantIds &&
          rule.triggerVariantIds.indexOf(String(item.variant_id)) !== -1
        );
      default:
        return false;
    }
  }

  function getMatchingRule(item) {
    if (!config || !config.rules) return null;
    for (var i = 0; i < config.rules.length; i++) {
      if (itemMatchesRule(item, config.rules[i])) return config.rules[i];
    }
    return null;
  }

  function findCompanionsForAddon(cart, addonVariantId) {
    return cart.items.filter(function (item) {
      if (!isCompanionItem(item)) return false;
      var addonId = item.properties[ADDON_PROP];
      if (addonId) return String(addonId) === String(addonVariantId);
      return String(item.variant_id) === String(addonVariantId);
    });
  }

  function getAddonDemand(cart) {
    var demand = {};

    cart.items.forEach(function (item) {
      if (isCompanionItem(item) || isAddonVariant(item.variant_id)) return;
      var rule = getMatchingRule(item);
      if (!rule) return;

      rule.addons.forEach(function (addon) {
        var addonId = String(addon.variantId);
        demand[addonId] = (demand[addonId] || 0) + item.quantity;
      });
    });

    return demand;
  }

  function cartHasCompanions(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(isCompanionItem);
  }

  function cartHasQualifyingParents(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return !isCompanionItem(item) && getMatchingRule(item);
    });
  }

  function getActiveRulesInCart(cart) {
    var active = [];
    var seen = {};

    cart.items.forEach(function (item) {
      if (isCompanionItem(item)) return;
      var rule = getMatchingRule(item);
      if (!rule || seen[rule.id]) return;
      seen[rule.id] = true;
      active.push(rule);
    });

    return active;
  }

  function resolveDiscountCode(cart) {
    var rules = getActiveRulesInCart(cart);

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (rule.discountAutoApply === false) continue;
      var code = (rule.discountCode || '').trim();
      if (code) return code;
    }

    return '';
  }

  function cartNeedsDiscount(cart) {
    if (!config || !config.enabled) return false;
    if (!cartHasCompanions(cart) || !cartHasQualifyingParents(cart)) return false;
    return !!resolveDiscountCode(cart);
  }

  function companionDiscountActive(cart) {
    if (!cart || !cart.items) return false;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isCompanionItem(item)) continue;
      if (item.final_price < item.original_price) return true;
      if ((item.line_level_discount_allocations || []).length > 0) return true;
    }

    return false;
  }

  function isDiscountApplied(cart, code) {
    if (!code || !cart) return false;
    return companionDiscountActive(cart);
  }

  function applyDiscountViaIframe(code) {
    return new Promise(function (resolve) {
      var iframe = document.createElement('iframe');
      var finished = false;
      var root = getRoot();

      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText =
        'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;border:0;';

      function finish(cart) {
        if (finished) return;
        finished = true;
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        resolve(cart);
      }

      var timeout = window.setTimeout(function () {
        fetchCart().then(finish);
      }, 4000);

      iframe.onload = function () {
        window.clearTimeout(timeout);
        window.setTimeout(function () {
          fetchCart().then(finish);
        }, 150);
      };

      iframe.src =
        root +
        'discount/' +
        encodeURIComponent(code) +
        '?redirect=' +
        encodeURIComponent(root + 'cart');
      document.body.appendChild(iframe);
    });
  }

  function applyDiscountViaFetch(code) {
    return fetch(getRoot() + 'discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'follow',
    }).then(function () {
      return fetchCart();
    });
  }

  function applyDiscountCode(code) {
    return applyDiscountViaIframe(code)
      .then(function (cart) {
        if (companionDiscountActive(cart)) {
          window.__argonAppliedDiscountCode = code;
          return cart;
        }
        return applyDiscountViaFetch(code).then(function (cartAfterFetch) {
          if (companionDiscountActive(cartAfterFetch)) {
            window.__argonAppliedDiscountCode = code;
            return cartAfterFetch;
          }
          window.__argonAppliedDiscountCode = null;
          console.warn(
            '[ArgonCartExtras] Discount code did not apply. Check that "' +
              code +
              '" exists, is active, and matches Buy X get Y rules in Shopify Admin.'
          );
          return cartAfterFetch;
        });
      })
      .catch(function (err) {
        window.__argonAppliedDiscountCode = null;
        console.warn('[ArgonCartExtras] Could not apply discount code', code, err);
        return fetchCart();
      });
  }

  function fetchCart() {
    return fetch(getRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json();
    });
  }

  function fetchBundledSections(cart) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    var sectionIds = sectionsToBundle.join(',');
    if (!sectionIds) return Promise.resolve(cart);

    return fetch(getRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        cart.sections = data.sections || {};
        return cart;
      })
      .catch(function () {
        return cart;
      });
  }

  function clearDiscountCode() {
    return fetch(getRoot() + 'discount/', {
      credentials: 'same-origin',
      redirect: 'manual',
    })
      .then(function () {
        window.__argonAppliedDiscountCode = null;
        return fetchCart();
      })
      .catch(function () {
        return fetch(getRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: '' }),
        })
          .then(function () {
            window.__argonAppliedDiscountCode = null;
            return fetchCart();
          })
          .catch(function () {
            window.__argonAppliedDiscountCode = null;
            return fetchCart();
          });
      });
  }

  function syncDiscountCode(cart) {
    var needsDiscount = cartNeedsDiscount(cart);
    var code = resolveDiscountCode(cart);
    var weApplied = !!window.__argonAppliedDiscountCode;

    if (!needsDiscount) {
      if (weApplied || companionDiscountActive(cart)) return clearDiscountCode();
      return Promise.resolve(cart);
    }

    if (!code) return Promise.resolve(cart);
    if (isDiscountApplied(cart, code)) return Promise.resolve(cart);
    return applyDiscountCode(code);
  }

  function cartAdd(items) {
    return fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function cartBatchUpdate(updates) {
    return fetch(getRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function cartChangeLine(lineKey, quantity, properties) {
    var body = { id: lineKey, quantity: quantity };
    if (properties !== undefined) body.properties = properties;

    return fetch(getRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function dispatchCartUpdated(cart) {
    syncCooldownUntil = Date.now() + SYNC_COOLDOWN_MS;
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'argon:sync',
          cart: cart,
          _argonSkipSync: true,
        },
      })
    );

    if (!cart.sections || !Object.keys(cart.sections).length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function publishCart(cart) {
    return fetchBundledSections(cart).then(function (cartWithSections) {
      dispatchCartUpdated(cartWithSections);
      return cartWithSections;
    });
  }

  function buildParentMergePlan(cart) {
    var groups = {};

    cart.items.forEach(function (item) {
      if (isCompanionItem(item) || isAddonVariant(item.variant_id)) return;

      var variantId = String(item.variant_id);
      if (!groups[variantId]) groups[variantId] = [];
      groups[variantId].push(item);
    });

    var updates = {};
    var propertyFixes = [];

    Object.keys(groups).forEach(function (variantId) {
      var lines = groups[variantId];
      if (lines.length <= 1) return;

      var totalQty = 0;
      var anyGift = false;

      lines.forEach(function (line) {
        totalQty += line.quantity;
        if (line.properties && line.properties[GIFT_PROP] === 'Ja') anyGift = true;
      });

      updates[lines[0].key] = totalQty;
      propertyFixes.push({
        key: lines[0].key,
        quantity: totalQty,
        properties: anyGift ? { Gaveinnpakning: 'Ja' } : {},
      });

      for (var i = 1; i < lines.length; i++) {
        updates[lines[i].key] = 0;
      }
    });

    return { updates: updates, propertyFixes: propertyFixes };
  }

  function applyPropertyFixes(cart, propertyFixes) {
    if (!propertyFixes.length) return Promise.resolve(cart);

    var chain = Promise.resolve(cart);
    propertyFixes.forEach(function (fix) {
      chain = chain.then(function (currentCart) {
        return cartChangeLine(fix.key, fix.quantity, fix.properties);
      });
    });

    return chain;
  }

  function companionProperties(addonVariantId) {
    var props = {};
    props[COMPANION_MARKER] = '1';
    props[ADDON_PROP] = String(addonVariantId);
    return props;
  }

  function companionNeedsMigration(item) {
    return isCompanionItem(item) && !item.properties[COMPANION_MARKER];
  }

  function buildSyncPlan(cart) {
    var demand = getAddonDemand(cart);
    var toAdd = [];
    var toRemove = [];
    var qtyUpdates = {};
    var toRemoveSeen = {};

    function queueRemove(key) {
      if (!key || toRemoveSeen[key]) return;
      toRemoveSeen[key] = true;
      toRemove.push(key);
    }

    Object.keys(demand).forEach(function (addonVariantId) {
      var requiredQty = demand[addonVariantId];
      var existing = findCompanionsForAddon(cart, addonVariantId);
      var existingQty = existing.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      if (requiredQty <= 0) {
        existing.forEach(function (item) {
          queueRemove(item.key);
        });
        return;
      }

      if (existing.length === 0) {
        toAdd.push({
          id: addonVariantId,
          quantity: requiredQty,
          properties: companionProperties(addonVariantId),
        });
        return;
      }

      var needsMigration = existing.some(companionNeedsMigration);

      if (!needsMigration && existing.length === 1 && existingQty === requiredQty) {
        return;
      }

      if (!needsMigration && existing.length >= 1) {
        qtyUpdates[existing[0].key] = requiredQty;
        for (var i = 1; i < existing.length; i++) {
          queueRemove(existing[i].key);
        }
        return;
      }

      existing.forEach(function (item) {
        queueRemove(item.key);
      });
      toAdd.push({
        id: addonVariantId,
        quantity: requiredQty,
        properties: companionProperties(addonVariantId),
      });
    });

    cart.items.forEach(function (item) {
      if (!isCompanionItem(item)) return;
      var addonId = String(item.properties[ADDON_PROP] || item.variant_id);
      if (!demand[addonId]) queueRemove(item.key);
    });

    cart.items.forEach(function (item) {
      if (!isMonkOrLegacyAddon(item)) return;
      queueRemove(item.key);
    });

    return { toAdd: toAdd, toRemove: toRemove, qtyUpdates: qtyUpdates };
  }

  function runSyncPass(cart, mergeParents) {
    var chain = Promise.resolve(cart);

    if (mergeParents) {
      var mergePlan = buildParentMergePlan(cart);

      if (Object.keys(mergePlan.updates).length) {
        chain = chain.then(function () {
          return cartBatchUpdate(mergePlan.updates);
        });
        chain = chain.then(function (mergedCart) {
          return applyPropertyFixes(mergedCart, mergePlan.propertyFixes);
        });
      }
    }

    return chain.then(function (currentCart) {
      var plan = buildSyncPlan(currentCart);
      var updates = {};

      plan.toRemove.forEach(function (key) {
        updates[key] = 0;
      });
      Object.keys(plan.qtyUpdates).forEach(function (key) {
        updates[key] = plan.qtyUpdates[key];
      });

      var next = Promise.resolve(currentCart);

      if (Object.keys(updates).length) {
        next = cartBatchUpdate(updates);
      }

      return next.then(function (cartAfterUpdates) {
        if (!plan.toAdd.length) return cartAfterUpdates;
        return cartAdd(plan.toAdd).then(fetchCart);
      });
    });
  }

  function syncCompanions(options) {
    if (!config) return Promise.resolve();

    var mergeParents = !!(options && options.mergeParents);

    if (syncing) {
      syncPending = true;
      if (mergeParents) syncPendingMerge = true;
      return Promise.resolve();
    }

    syncing = true;

    return fetchCart()
      .then(function (cart) {
        if (!config.enabled) return null;
        return runSyncPass(cart, mergeParents);
      })
      .then(function (cart) {
        if (!cart) return null;
        return syncDiscountCode(cart);
      })
      .then(function (finalCart) {
        if (!finalCart) return;
        return publishCart(finalCart);
      })
      .catch(function (err) {
        console.warn('[ArgonCartExtras] Sync failed', err);
      })
      .finally(function () {
        syncing = false;
        if (syncPending) {
          var pendingMerge = syncPendingMerge;
          syncPending = false;
          syncPendingMerge = false;
          syncCompanions({ mergeParents: pendingMerge });
        }
      });
  }

  function requestSync(mergeParents, delay) {
    if (!config || !config.enabled) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      syncCompanions({ mergeParents: mergeParents });
    }, typeof delay === 'number' ? delay : 0);
  }

  function onCartChange(event) {
    if (!config) return;
    if (event.detail && event.detail._argonSkipSync) return;
    if (Date.now() < syncCooldownUntil) return;

    var baseEvent = event.detail && event.detail.baseEvent;
    if (baseEvent === 'argon:sync' || baseEvent === 'variant:add') return;
    if (!config.enabled) return;

    if (baseEvent === 'line-item:change') {
      requestSync(false, 250);
    }
  }

  function onVariantAdd() {
    requestSync(true, 100);
  }

  function disableMonk() {
    if (document.getElementById('argon-disable-monk-css')) return;
    var style = document.createElement('style');
    style.id = 'argon-disable-monk-css';
    style.textContent =
      '[class*="monk" i],[id*="monk" i],[data-monk],[data-mr-offer],mr-cart,mr-offer,.mr-embedded-widget{display:none!important;visibility:hidden!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  function init() {
    config = readConfig();
    if (!config) return;

    disableMonk();
    document.documentElement.addEventListener('cart:change', onCartChange);
    document.documentElement.addEventListener('variant:add', onVariantAdd);

    if (config.enabled) {
      syncCompanions();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ArgonCartExtras = {
    sync: syncCompanions,
    getConfig: function () {
      return config;
    },
  };
})();
